export default __webpack_public_path__ + "static/media/farmer.604f416c.jpg";